<!--
 * 传统头部组件
 * @author liutong
 * @time 2024-11-22
 *
-->
<!-- VUE模板(html)代码 start -->
<template>
  <div class="header">
    <div class="left">
      <div class="logo_wrap">
        <img src="../../../assets/images/login/logo.png" alt="" />
        武汉市房屋建筑工程招标投标监督管理系统
      </div>
    </div>
    <div class="right">
      <div class="size">
        <span>文本缩放：</span>
        <span class="s" @click="fun_Zoomout"><i class="el-icon-plus"></i></span>
        <span class="si">{{ Math.floor(size * 100) }}%</span>
        <span class="s" @click="fun_Zoomin"><i class="el-icon-minus"></i></span>
      </div>
      <div class="reg right-left" @click="fun_ShowHomePage" v-if="(flag == '' || flag == null) && !registryFlag">
        <i class="el-icon-shouye"></i>
        <span>首页</span>
      </div>
      <el-tooltip class="item" popper-class="popper" effect="light" placement="bottom">
        <div slot="content" class="content">
          <span @click="fun_PasswordUpdate" v-if="((flag == '' || flag == null) && userFlag != '工作人员') && !registryFlag">修改密码</span>
          <span @click="fun_LoginOut">退出登录</span>
        </div>
        <el-button icon="el-icon-user-solid" v-if="userFlag === '工作人员' || registryFlag">
          {{ userInfo.realName }}<i class="el-icon-arrow-down"></i>
        </el-button>
        <el-button icon="el-icon-user-solid" v-else>
          {{ "用户名" }}：{{ userInfo.realName.length > 20 ? userInfo.realName.substring(0, 20) + "..." : userInfo.realName }}<i class="el-icon-arrow-down"></i>
        </el-button>
      </el-tooltip>
    </div>
  </div>
</template>
<!-- VUE模板(html)代码 end -->

<!-- JS代码 start -->
<script>
/*
 * 导入axios接口
 * 登录：login
 * @author 滕威
 */
import { fun_GetAction } from "@/api";
import { mapState } from "vuex";
import { Loading } from "element-ui";
import Layout from "../Home.vue";
import router from "../../../router/router";
import store from "../../../store";
import VueRouter from 'vue-router';
/**
 * 导入加密组件
 * @author 滕威
 */
export default {
  inject: ["reload"],
  data() {
    return {
      loginType: null, // 登录身份
      flag: null,// 判断显示菜单
      mmfzd: null,// 密码复杂度
      noPageflag: null,// 登录信息更新标志
      supervisionInformFlag: false,// 进入监管通知页面
      regPasswordUpdateFlag: false,// 进入修改密码界面（注册人）
      regSmPasswordUpdateFlag: false,// 进入修改密码界面（注册人-扫码）
      corpPasswordUpdateFlag: false,// 进入修改密码界面（企业）
      corpSmPasswordUpdateFlag: false,// 进入修改密码界面（企业-扫码）
      supervisionFlag: false,// 监管页面标志
      corpFlag: false,// 进入交易人界面
      registryFlag: false,// 进入注册人界面
      fullLoading: null,  // 全局加载
      otherRouters: [],
      userFlag: null, // 用户类型
      userId: null, // 用户编号
      // 缩放比例
      size: 1,
    };
  },
  // 声明组件
  components: {
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  created() {
    // 添加对 sessionStorage 的监听
    window.addEventListener("setItem", () => {
      // 当sessionStorage 中的lang值发生变化， 给组件中的值重新赋值
      this.flag = sessionStorage.getItem("flag") ? sessionStorage.getItem("flag") : null;
      this.userFlag = sessionStorage.getItem("userFlag") ? sessionStorage.getItem("userFlag") : null;
    });
  },
  mounted() {
  },
  /**
   * 自定义方法模块
   */
  methods: {
    /**
     * 首页跳转
     * @param e
     */
    fun_ShowHomePage(){
      // 工作人员首页跳转
      // this.fun_ShowSupervisorHomePage();
      // 跳转工作台
      this.$router.push({path: "/staffWorkbench" });
    },
    /**
     * 全局加载
     * @author zhouzhou
     */
    fun_Loading() {
      this.fullLoading = Loading.service({
        lock: true,
        text: "加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.8)"
      });
    },
    /**
     * 跳转用户注册
     * @author 滕威
     */
    fun_UserReg() {
      this.$router.push({ path: "/home?type=reg" });
    },
    /**
     * 跳转意见反馈
     * @author 滕威
     */
    fun_MsgMessagBoard(){
      // 跳转
      this.$router.push({ path: "/msgMessagBoard" });
    },
    /**
     * 跳转工作台
     * @author 滕威
     */
    fun_Workbench() {
      // 跳转
      this.$router.push({ path: "/home" });
    },
    /**
     * 修改密码
     * @author 滕威
     */
    fun_PasswordUpdate(){
      // 跳转
      this.$router.push({ path: "/password" });
    },
    /**
     * 退出登录方法
     * @author 滕威
     */
    fun_LoginOut() {
      // 询问框
      this.$confirm("您确定退出吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        // 调用登录接口
        fun_GetAction("/loginOut").then(res => {
          // 解构res.data
          const { result, msg } = res.data;
          // 判断接口参数result
          if (result) {
            // 记录登录类型
            let loginType = sessionStorage.getItem("loginType");
            // 清空sessionStorage
            sessionStorage.clear();
            // 重置
            sessionStorage.setItem("loginType", loginType);
            var herf = window.location.href;
            // 截取
            var array = herf.substring(0, herf.indexOf("#") + 2);
            // 跳转到登录页
            window.location.href = array;
            // 刷新页面
            window.location.reload()
          } else {
            // 错误消息提示
            if (msg) this.$message.error(msg);
          }
        });
      });
    },
    /**
     * 设置比例
     * @author 滕威
     */
    fun_SetSize() {
      document.body.style.zoom = this.size;
      document.body.style.cssText +=
        "; -moz-transform: scale(" +
        this.size +
        ");-moz-transform-origin: 0 0; ";
    },
    /**
     * 放大比例调用
     * @author 滕威
     */
    fun_Zoomout() {
      this.size = this.size + 0.1;
      this.fun_SetSize();
    },
    /**
     * 缩小比例调用
     * @author 滕威
     */
    fun_Zoomin() {
      this.size = this.size - 0.1;
      this.fun_SetSize();
    },
  }
};
</script>
<!-- JS代码 end -->

<!-- css样式 start-->
<style lang="scss" scoped>
.header {
  width: 100%;
  display: flex;
  display: -webkit-flex;
  display: -ms-flexbox;
  justify-content: space-between;
  //background: #d9534f;
  background: url("../../../assets/images/staffElHeader.png") no-repeat center center;
  background-size: cover;
  height: 100%;
  box-sizing: border-box;
  .left {
    color: #ffffff;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .logo_wrap {
      padding-left: 16px;
      font-family: Source Han Sans SC;
      display: flex;
      align-items: center;
      font-weight: bold;
      font-size: 28px;
      color: #FFFFFF;
      > img {
        margin-right: 8px;
      }
      > span {
        font-size: 22px;
      }
    }
  }
  .right {
    display: flex;
    display: -webkit-flex;
    display: -ms-flexbox;
    justify-content: flex-end;
    padding-right: 15px;
    color: #ffffff;
    .size {
      margin-right: 10px;
      display: flex;
      align-items: center;
      .s {
        display: inline-block;
        width: 18px;
        height: 18px;
        line-height: 18px;
        border: 1px solid #FFFFFF;
        margin-right: 10px;
        cursor: pointer;
      }
      .si {
        margin-right: 10px;
      }
    }
    .right-icon {
      cursor: pointer;
      margin-right: 20px;
      display: flex;
      align-items: center;
      img {
        margin-right: 3px;
      }
    }
    .el-tooltip,.el-tooltip:hover{
      padding: 0;
      background: none;
      border: 0;
      color: #FFFFFF;
    }
    /deep/.switchover,.switchover:hover{
      background: #0E70B5;
      border: 1px solid #FFD0CE;
      height: fit-content;
      padding: 14px 18px;
      border-radius: 50px;
      margin: auto;
      margin-right: 20px;
      span{
        font-weight: bold;
        i{
          margin-left: 8px;
          transition: transform .3s;
        }
      }
    }
    .switchover:hover{
         span{
          i{
            transform: rotate(-180deg);
          }
        }
      }
    .right-left {
      display: flex;
      align-items: center;
      position: relative;
      margin-right: 20px;
      > i {
        padding-right: 5px;
        font-size: 18px;
      }
      > span {
        display: inline-block;
        max-width: 190px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        cursor: pointer;
      }
      .hover-realname {
        opacity: 0;
        transition: opacity 0.8s;
        color: #333333;
        background: #fff;
        position: absolute;
        top: 70%;
        width: 100%;
        z-index: 999;
        border-radius: 5px;
        line-height: 20px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        transform-origin: center bottom;
        word-break: break-all;
        display: flex;
        flex-direction: column;
        align-items: center;
        span{
          color: #666666;
          padding: 10px 5px;
          width: 100%;
          &:first-child{
            border-bottom: 1px solid #e6e6e6;
          }
        }
      }
    }
    .right-right {
      display: flex;
      align-items: center;
      cursor: pointer;
      > i {
        padding-right: 5px;
      }
    }
    .right-left:hover .hover-realname {
      opacity: 1;
      transition: opacity 0.8s;
    }
  }
}
.el-tooltip__popper.popper{
  border-color: #FFFFFF !important;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1) !important;
  padding: 5px 0 !important;
  .content{
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    width: 100%;
    span{
      color: #666666;
      padding: 10px 40px;
      cursor: pointer;
      &:first-child{
        border-bottom: 1px solid #e6e6e6;
      }
    }
    p{
      color: #666666;
      padding: 10px 40px;
      border-bottom: 1px solid #e6e6e6;
      cursor: pointer;
      &:last-child{
        border: 0;
      }
    }
  }
}
</style>
<style lang="scss">
.el-tooltip__popper.popper{
  border-color: #FFFFFF !important;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1) !important;
  padding: 0 !important;
  top: 65px !important;
  .content{
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    width: 100%;
    span{
      color: #666666;
      padding: 10px 30px;
      cursor: pointer;
      &:first-child{
        border-bottom: 1px solid #e6e6e6;
      }
    }
    p{
      color: #FFFFFF;
      padding: 10px 30px;
      cursor: pointer;
      color: #666666;
      border-bottom: 1px solid #e6e6e6;
      display: flex;
      align-items: center;
      span{
        border: 0 !important;
        padding: 0 !important;
        color: #666666 !important;
      }
      img{
        margin-right: 10px !important;
      }
      &:last-child{
        border: 0;
      }
    }
  }
}
.el-tooltip__popper.popper .popper__arrow {
  border: none;
  border-color: #FFFFFF !important;
  background: #FFFFFF !important;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1) !important;
  font-size: 18px;
}
</style>
<!-- css样式 end-->
